import { Context } from '@nuxt/types'
import {
  GetMapByDate,
  MapByDateParams,
  MapRoutes,
  ReplaceParam,
  SaFirstVideoYear,
  SaFirstYear,
  SitemapType,
} from '~/assets/ts/sitemap/utils'
import { GetRoutes } from '~/assets/ts/sitemap/routes'
import { RenderSitemap } from '~/assets/ts/sitemap/xml'
import { apiTimestampToJsDate } from '~/assets/ts/utils/date'

export function GetVideoIndexes(locales: string[]): string[] {
  const params = {
    sitemap: SitemapType.Videos,
    locales,
    startYear: SaFirstYear,
  } as MapByDateParams
  const years = GetMapByDate(params, SaFirstVideoYear)
  const months = GetMapByDate({
    ...params,
    startYear: SaFirstVideoYear,
    startMonth: 1,
  })
  return [...years, ...months]
}

export async function VideosSitemap(
  ctx: Context,
  locale: string,
  params: string[]
) {
  const videos = await ctx.$apiClient.getSitemapVideoSermons({
    year: parseInt(params[0]),
    month: params[1] ? parseInt(params[1]) : undefined,
  })
  const routes = GetRoutes(ctx, locale, SitemapType.Sermons, 2)
  const list = MapRoutes(routes, videos, (video, { path, param }) => {
    const [sermonID, updateTimestamp] = video
    let url = ReplaceParam(path, sermonID, param)
    url = ReplaceParam(url, '', 'mediaType')
    return {
      url,
      priority: 1,
      updated: apiTimestampToJsDate(updateTimestamp),
      video,
    }
  })
  return RenderSitemap(ctx, SitemapType.Videos, list)
}
